import React, { ChangeEvent, useEffect, useState } from 'react'
import InputMask from 'react-input-mask'
import { Autocomplete, Checkbox, Input, Radio } from '../../ui-components'
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {handleFormChange, formFields} from './entity-slice';
import '../../assets/styles/default-form.scss'
import { CITIES_UPDATE, LONG_TERM_TYPES } from '../../services/constants'
import styles from './entity.module.scss'
import { Datepicker } from '../../shared'

const EntityForm = ({entity}) => {
  const {form, validationFields} = useAppSelector(state => state.entity)
  const [city, setCity] = useState<string>('')
  const [longTerm, setLongTerm] = useState<string>('')
  const dispatch = useAppDispatch()

  useEffect(()=>{
    if(entity){
      for(const prop in entity){
        if(formFields.includes(prop)){
          if (prop === 'city') {
            for (const region of CITIES_UPDATE) {
              if (region.value === entity.city) {
                setCity(region.value)
              }
            }
          } else if (prop === 'long_term') {
            for (const term of LONG_TERM_TYPES) {
              if (term.value === entity.long_term) {
                setLongTerm(term.value)
              }
            }
          }
          dispatch(handleFormChange({key: prop, value:entity[prop]}))
        }
      }
    }
  }, [entity])

  // handle input change event
  const handleInputChange = (event: ChangeEvent) => {
    const element = event.target as HTMLInputElement
    let value = element.value.replace(/^\+\d{1,3}\s?/, "")
    value = value.replace(/[\(\)\-\s]/g, "")
    dispatch(handleFormChange({key: element.name, value}))
  }

  const selectCity = (el) => {
    setCity(el.value)
    dispatch(handleFormChange({key: 'city', value: el.value }))
  }
  const selectTerm = (el) => {
    setLongTerm(el.value)
    dispatch(handleFormChange({key: 'long_term', value: el.value }))
  }

  return (
    <div id={styles.entityForm} className="overflow-scroll">
      <div className="temp-03-form">
        <div className={'mb-40'}>
          <Input name='name'
                 error={!validationFields.name}
                 onChange={handleInputChange}
                 value={form.name} label="Имя"/>
        </div>
        <div className={'mb-40'}>
          <Input name='organization_name'
                 error={!validationFields.organization_name}
                 onChange={handleInputChange}
                 value={form.organization_name} label="Название"/>
        </div>
        <div className={'wrapper'}>
          <InputMask mask="+7 (999) 999-99-99" maskChar=" "
                     className={styles.input}
                     name='primary_phone'
                     error={!validationFields.primary_phone}
                     onChange={(e) => e && handleInputChange(e)}
                     value={form.primary_phone} label="Телефон">
            {(inputProps) => <Input {...inputProps} />}
          </InputMask>
          <Input name='email'
                 error={!validationFields.email}
                 onChange={handleInputChange}
                 value={form.email} label="Почта"/>
        </div>
        <div className={'wrapper'}>
          <Autocomplete className={styles.search}
                        options={CITIES_UPDATE}
                        isClearable={false}
                        value={city}
                        label={'Город'}
                        onChange={(data) => selectCity(data)}
                        optionLabel={'value'}
                        optionValue={'value'}/>
          <Input name='address'
                 error={!validationFields.address}
                 onChange={handleInputChange}
                 value={form.address} label="Адрес"/>
          <Input name='taxpayer_number'
                 error={!validationFields.taxpayer_number}
                 onChange={handleInputChange}
                 value={form.taxpayer_number} label="ИНН"/>
        </div>
        <div className="wrapper">
          <Autocomplete className={styles.search}
                        options={LONG_TERM_TYPES}
                        isClearable={false}
                        value={longTerm}
                        label={'Способ Оплаты'}
                        onChange={(data) => selectTerm(data)}
                        optionLabel={'value'}
                        optionValue={'value'}/>
          <Input name='long_term_number'
                 onChange={handleInputChange}
                 value={form.long_term_number}
                 label="Номер договора"
          />
        </div>
        <div className="wrapper">
          <Datepicker error={!validationFields.long_term_start}
                      handleDateChange={(date) => dispatch(handleFormChange({
                        key: 'long_term_start',
                        value: date
                      }))}
                      value={form.long_term_start || new Date().toString()} label={"Контракт начало: "}/>
          <Datepicker error={!validationFields.long_term_date}
                      handleDateChange={(date) => dispatch(handleFormChange({
                        key: 'long_term_date',
                        value: date
                      }))}
                      value={form.long_term_date || new Date().toString()} label={"Контракт до: "}/>
        </div>
      </div>
    </div>
  )
}

export default EntityForm
